// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardActivity_wrapper__byLWF","left":"DashboardActivity_left__hLbdR","right":"DashboardActivity_right__cmS+4"};